import { createFileRoute } from "@tanstack/react-router";
import PaymentSuccessPage from "../components/PaymentSuccessPage";

export const Route = createFileRoute("/payment-success")({
  component: () => <PaymentSuccessPage />,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      paymentGuid: (search.paymentGuid as string) || undefined,
    };
  },
});
